import React, { useRef, useState } from "react";
import BaseDialog from "../modelDialogs/BaseDialog";
import Page from "../models/Page";
import Logger from "../Logger";
import FloorDialog from "../modelDialogs/FloorDialog";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import PageGroup, { fixedPageGroupTags } from "../models/PageGroup";
import { BuildingPlanList, LoadNewBuildingPlansButton } from "./Quickstart/LoadFloorPlans";
import Floor from "../models/Floor";
import { EventKey } from "../eventLogger/EventKeys";

const logger = new Logger();

export default function UploadFloorPlansDialog(props: {
  page: Page;
  onChange: () => void;
  fromFloorCreation?: {
    tag: string;
    name: string;
    cabinetId: string;
    background: { page: Page | unknown; pageNumber: number };
  };
}) {
  const { page, onChange, fromFloorCreation } = props;
  const [selectedPage, setSelectedPage] = useState<{ page: Page | unknown; pageNumber: number }>({
    page: fromFloorCreation?.background.page || page,
    pageNumber: fromFloorCreation?.background.pageNumber || 0,
  });
  const documentPageGroup = useRef(getDocumentPageGroup());
  const floor = page.parent as Floor;
  useOnChangeWatcher(documentPageGroup.current);

  function getDocumentPageGroup(): PageGroup {
    let pageGroup = new PageGroup();
    /// get pageGroup

    if (state.pageGroups.size == 0) {
      // init state (pageGroup)
      PageGroup.initPageGroups();
    }
    state.pageGroups.forEach((pg) => {
      if (pg.tag == fixedPageGroupTags.buildingPlans) {
        pageGroup = pg;
      }
    });

    return pageGroup;
  }

  function onSelect(info: { page: Page; pageNumber: number }) {
    const { page, pageNumber } = info;
    setSelectedPage({ page: page, pageNumber: pageNumber });
  }
  function openFloorCreation(): boolean {
    if (fromFloorCreation) {
      state.dialogManager.openDialog(
        <FloorDialog
          parent={state.floors}
          fromSubmittals={{
            tag: fromFloorCreation.tag,
            name: fromFloorCreation.name,
            cabinetId: fromFloorCreation.cabinetId,
            background: selectedPage,
          }}
        />,
      );
      return false;
    }
    return true;
  }
  function getDefaultSelectedPage(): any {
    if (fromFloorCreation) {
      return { page: fromFloorCreation.background.page, pageNumber: fromFloorCreation.background.pageNumber };
    }
    return { page: page.pdfPageRef, pageNumber: page.pageNumber };
  }

  return (
    <BaseDialog
      title={`${floor?.tag || fromFloorCreation?.tag || ""} ${floor?.name || fromFloorCreation?.name || ""}`}
      onOk={() => {
        if (fromFloorCreation) {
          return openFloorCreation();
        }
        const selectedPagePage = selectedPage.page as Page;
        if (floor && selectedPagePage) {
          // set pdf as background
          if (selectedPagePage.className == "PdfPageReference") {
            const pdfDocument = selectedPagePage.parent as Page;

            page.setBackgroundImageFromBuildingPdf(pdfDocument, selectedPage.pageNumber);
          } else if (page.className == "Page") {
            page.setBackgroundImageFromBuildingPdf(selectedPagePage as Page, 1);
          }
          state.eventLogger.addEvent(EventKey.BackgroundImageSet, {
            pageId: page.id,
            source: "pdf",
          });
          onChange();
          page.raiseOnChange("pdfPageRef");
          return true;
        } else {
          // delete pdf from floor
          state.eventLogger.addEvent(EventKey.BackgroundImageRemoved, {
            pageId: page.id,
            source: "pdf",
          });
        }
        if (selectedPage.page && selectedPage.pageNumber > 0) {
          if (fromFloorCreation) {
          }
          return true;
        }
        return false;
      }}
      onClose={openFloorCreation}
      onAbort={openFloorCreation}
      noOkButton={selectedPage.pageNumber == 0}
      moreButtons={<LoadNewBuildingPlansButton documentPageGroup={documentPageGroup.current} />}
    >
      <div
        style={{
          // maxWidth: "100%",
          height: "400px",
          width: "calc(100% + 40px)",
          margin: "-20px",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          //alignItems: "center",
        }}
      >
        <div style={{ textAlign: "center" }}>
          {state.translate(
            "uploadFloorPlansDialog.uploadFloorPlansDescription",
            "Hier können sie eine Seite auswählen und diese als Hintergundbild Ihrer Etage verwenden.",
          )}
        </div>
        <div style={{ height: "10px", borderTop: "1px solid lightgrey", width: "100%", marginTop: "10px" }} />
        <BuildingPlanList
          onChange={() => {
            // kein redraw nötig !!
          }}
          documentPageGroup={documentPageGroup.current}
          selectedElem={onSelect}
          defaultSelectedPage={getDefaultSelectedPage()}
        />
      </div>
    </BaseDialog>
  );
}
